import APITable from '@console/components/project/brandCheck/APITable';
import type { AppState } from '@console/reducers';
import { getGiftCardConfigsForDisplay } from '@console/selectors/projectDetail/giftCardConfigs';
import { getGifteeBoxConfigs } from '@console/selectors/projectDetail/gifteeBoxConfigs';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  giftCardConfigs: getGiftCardConfigsForDisplay(state),
  gifteeBoxConfigs: getGifteeBoxConfigs(state)
});

const mapDispatchToProps = () => ({});

export type APITablePropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type APITablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(APITable);
